import React, { Component } from "react";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import axios from "axios";
import { withTranslation } from "react-i18next";

//import { createMuiTheme, ThemeProvider } from '@material-ui/core';
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
class DeleteContact extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      open: true,
      compte: "",
      poste: "",
      id: "",

      redirectToReferrer: false,
    };
  }
  getAllcontact = async () => {
    var lien = window.location.href;
    //console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = await axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}`,
        config,
      )
      .then((res) => {
        const data = res.data.carnet_adresse;
        localStorage.setItem("tabcontact", JSON.stringify(data));

        // For displaying Data
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  componentDidMount() {
    // const cpte =  localStorage.getItem("compte");
    // const post =  localStorage.getItem("poste");
    // this.setState({ poste: post });
    // this.setState({ compte: cpte });
    this.setState({ id: this.props.id });
    // console.log("this.state.id");
  }
  setOpen() {
    this.setState({ open: false });
  }

  onSubmit(e) {
    e.preventDefault();

    const data = new URLSearchParams();
    data.append("compte", compte);
    data.append("poste", poste);
    data.append("action", "delete");
    data.append("id", this.props.id);
    data.append("nom_prenom", "");
    data.append("email", "");
    data.append("adresse", "");
    data.append("tel_portable", "");
    data.append("tel_fix", "");
    data.append("tel_3", "");
    data.append("tel_4", "");
    data.append("tel_5", "");
    data.append("commentaire", "");

    const url = `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CRUDContactCarnetAdresseIPBXV3API`;

    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    axios
      .post(url, data, config)
      .then((res) => {
        // this.getAllcontact();
        this.setState({ redirectToReferrer: true });
        this.props.toggle();
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });

    this.setState({
      id: "",
    });
  }

  render() {
    const { t } = this.props;
    // if (this.state.redirectToReferrer == true) {
    //   //   var link = "/contact";
    //   //   window.location.replace(link);
    //   window.location.reload();
    // } else {
    return (
      <Transition.Root show={this.props.showModal} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto"
          open={this.state.open}
          onClose={this.props.handleClose}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="dark:bg-gray-800 dark:text-white inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    onClick={this.props.handleClose}
                  >
                    <span className="sr-only">Close</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="dark:text-white text-lg leading-6 font-medium text-gray-900"
                    >
                      {t("contactdelete")}
                    </Dialog.Title>
                  </div>
                </div>

                <div className="mt-10 sm:mt-0">
                  <div className="mt-5 md:mt-0 md:col-span-1">
                    <form onSubmit={this.onSubmit}>
                      <div className="flex -px-8 -py-8 mt-8 ml-52 text-right bottom-0 right-0 sm:px-6">
                        <div className="px-2">
                          <button
                            value="Supprimer"
                            type="button"
                            onClick={this.props.handleClose}
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm  font-medium rounded-md text-white bg-gray-400 text-base   hover:bg-gray-700 focus:outline-none "
                          >
                            {t("annuler")}
                          </button>
                        </div>
                        <div className="px-2">
                          <input
                            value={t("delete")}
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm   rounded-md  bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none "
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }
}
//}
export default withTranslation("common")(DeleteContact);
